import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Column } from 'styled/alignment/Column';
import CardProducerProfile from './parts/CardProducerProfile';
import AffiliateEntryCard from './parts/AffiliateEntryCard';
import styled from 'styled-components';
import breakpoints from 'theme/breakpoints';
import producerProfilesApi from 'api/requests/producerProfiles';
import Loader from 'components/_UI/Loader';
import NotResultDashBoard from 'components/commons/NotResultDashBoard';
import Modal from 'components/_UI/Modal';
import ProducerProfileForm from './create/ProducerProfileForm';
import Text from 'components/_UI/Text';
import useToast from 'hooks/useToast';
import ToastContainer from 'components/_UI/ToastsContainer';
import paths from 'routes/paths';

export default function ProducerProfile({ editProfileClick, onProfileLoaded = () => false }) {
  const [loader, setLoader] = useState(false);
  const [producerData, setProducerData] = useState(null);
  const [isCreate, setIsCreate] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const { toast, toasts } = useToast();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!editProfileClick) {
      getProducerData();
    }

    if (editProfileClick && producerData) {
      setIsEdit(producerData);
    }
  }, [editProfileClick]);

  async function getProducerData() {
    setLoader(true);
    try {
      const { data } = await producerProfilesApi.me();
      setProducerData(data?.data);
      onProfileLoaded(!!data?.data);
    } catch (error) {
      setProducerData(null);
      onProfileLoaded(false);

      // Veio do "Falta pouco para criar seu evento": já abre o formulário, sem
      // pedir mais um clique em "Criar perfil de produtor".
      if (error?.response?.status === 404 && location.state?.backToCreateEvent) {
        setIsCreate(true);
      }
    } finally {
      setLoader(false);
    }
  }

  function onCloseCollapse() {
    setIsCreate(false);
    setIsEdit(false);
  }

  function onSuccess(text) {
    toast.success(`Perfil de produtor ${text} com sucesso!`);
    onCloseCollapse();

    // Quem veio do "Falta pouco para criar seu evento" volta a ele: o que ainda
    // faltar (dados bancários) aparece lá, ou o formulário do evento já abre.
    if (text === 'criado' && location.state?.backToCreateEvent) {
      navigate(`${paths.dashboard.events}?create=1`, { replace: true });
      return;
    }

    getProducerData();
  }

  return (
    <>
      <ToastContainer toasts={toasts} />
      {loader ? (
        <Loader />
      ) : (
        <>
          {producerData ? (
            <ProfileContainer>
              <CardProducerProfile data={producerData} />
              <AffiliateEntryCard fullWidth />
            </ProfileContainer>
          ) : (
            <NotResultDashBoard
              ilustration={'adding-pin-in-map'}
              text={
                <>
                  <Text name='highlight'>Crie seu perfil de produtor</Text>
                  <Text>Complete seu perfil de produtor para começar a criar e gerenciar seus eventos na plataforma.</Text>
                </>
              }
              textButton={'Criar perfil de produtor'}
              onClick={() => setIsCreate(true)}
            />
          )}
        </>
      )}
      <Modal
        isOpen={!!(isCreate || isEdit)}
        onClose={onCloseCollapse}
        closeButton
        isCircularClose
        size='medium'
        childrenOverflowY='scroll'
      >
        <ProducerProfileForm
          onClose={onCloseCollapse}
          isEdit={isEdit}
          onSuccess={onSuccess}
        />
      </Modal>
    </>
  );
}

const ProfileContainer = styled(Column)`
  width: 100%;
  flex-wrap: wrap;
  @media screen and (min-width: ${breakpoints.lg}) {
    flex-direction: row;
  }
`;
